import { apiPost } from './apiClient.js';

/**
 * Intent service for creating admin change intents
 */

/**
 * Create an intent for a high-impact mutation
 * @param {object} params - Intent parameters
 * @param {string} params.action - Action to be performed (e.g., 'integration.enable')
 * @param {string} params.targetType - Type of resource (e.g., 'integration')
 * @param {string} params.targetId - ID of resource (e.g., 'MONDAY')
 * @param {string} params.reason - Human-readable reason (required, non-empty)
 * @returns {Promise<object>} - Response with intentAuditEventId and requestId
 */
export async function createIntent({ action, targetType, targetId, reason }) {
  if (!reason || !reason.trim()) {
    throw new Error('Reason is required and must be non-empty');
  }

  const response = await apiPost('/admin/intent', {
    action,
    target_type: targetType,
    target_id: targetId,
    reason: reason.trim(),
    risk_acknowledged: true,
  });

  // `apiClient` returns the unwrapped payload; intentAuditEventId must be present in payload.
  const intentAuditEventId = response.intentAuditEventId || response.auditEventId;

  if (!intentAuditEventId) {
    throw new Error('Failed to create intent: intentAuditEventId not returned');
  }

  return {
    intentAuditEventId,
    ...response,
  };
}

